import {InputHTMLAttributes} from "react";
import {cva, type VariantProps } from "class-variance-authority";
import {cn} from "../../lib/Utils";


// removed: w-full
const inputProps = cva(
    "bg-surface-950 border border-surface-700 rounded-lg text-surface-200 placeholder:text-surface-600",
    {
        variants: {
            intent: {
                primary: "",
                error: "border-red-700 focus:border-red-700 focus:ring-red-700/30",
                success: "border-green-500 focus:border-green-500 focus:ring-green-500/30",
            },
            inputSize: {
                small: "h-12 px-4",
                medium: "px-3.5 py-3",
                large: "h-10 pl-12 pr-4",
            },
            focus : {
                true: "focus:outline-none focus:border-brand-500 focus:ring-2 focus:ring-brand-500/30",
                false: ""
            }
        },
        defaultVariants: {
            intent: "primary",
            inputSize: "medium",
            // focus: true,
        },
    }
);

export interface InputProps
    extends InputHTMLAttributes<HTMLInputElement>,
        VariantProps<typeof inputProps> {}

const Input = ({ className, intent, inputSize, ...props }: InputProps) => (
    <input
        className={cn(inputProps({ intent, inputSize }), className)}
        {...props}
    />
);


Input.displayName = "Input"; 
export { Input };





